import { render, staticRenderFns } from "./AssociazioneAppPage.vue?vue&type=template&id=5579a422&scoped=true"
import script from "./AssociazioneAppPage.vue?vue&type=script&lang=js"
export * from "./AssociazioneAppPage.vue?vue&type=script&lang=js"
import style0 from "./AssociazioneAppPage.vue?vue&type=style&index=0&id=5579a422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5579a422",
  null
  
)

export default component.exports